module.exports = __webpack_public_path__ + "images/official-servicee41bf1214bf022e16654a5f95657eb5f.jpg";